import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ExternalLink, Youtube } from "lucide-react";

export default function VideoModal({ video, open, onClose }) {
  if (!video) return null;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl bg-surface border-white/10 text-bone p-0 overflow-hidden" data-testid="video-modal">
        {video.youtube_id ? (
          <div className="aspect-video w-full bg-black">
            <iframe title={video.title} className="w-full h-full"
              src={`https://www.youtube.com/embed/${video.youtube_id}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        ) : (
          <div className="aspect-video w-full bg-gradient-to-br from-surface2 to-black flex flex-col items-center justify-center gap-5 p-8 text-center">
            <Youtube className="text-gold" size={48} strokeWidth={1.2} />
            <p className="text-bone/70 max-w-md">This lecture is hosted on an external platform. Open it to watch the full teaching.</p>
            <a href={video.external_url} target="_blank" rel="noreferrer" data-testid="video-modal-external"
              className="inline-flex items-center gap-2 bg-gold text-black px-8 py-3 font-medium hover:bg-gold2 transition-colors">
              <ExternalLink size={18} /> Watch Now
            </a>
          </div>
        )}
        <div className="p-6">
          <p className="text-xs uppercase tracking-widest text-gold mb-2">{video.teacher}</p>
          <h2 className="font-serif text-2xl md:text-3xl text-bone mb-3">{video.title}</h2>
          <p className="text-bone/60 leading-relaxed">{video.description}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
